import { isPlainObject } from 'lodash';
import { safeParseJson } from 'utils/general';
import { StorageKeys } from 'types/LocalStorage';
import { FeatureFlags } from './feature-flags.types';
import { featureFlagsSchema } from './feature-flags.schemas';

interface UpdateFeatureFlags {
  flags: Partial<FeatureFlags>;
}

export const readFeatureFlags = (): FeatureFlags => {
  const raw = safeParseJson(localStorage.getItem(StorageKeys.featureFlags));

  return featureFlagsSchema.parse(isPlainObject(raw) ? raw : {});
};

export const loaders = {
  getFeatureFlags: () => Promise.resolve(readFeatureFlags()),
  updateFeatureFlags: ({ flags }: UpdateFeatureFlags) => {
    localStorage.setItem(
      StorageKeys.featureFlags,
      JSON.stringify({
        ...readFeatureFlags(),
        ...flags,
      }),
    );

    return Promise.resolve();
  },
};
